import React from 'react'

function IconBoxShop14({ fill, stroke }) {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.38894 13V7L1.38892 4.5C1.38893 2.567 2.95594 1 4.88894 1H7.38894H13.3889L13.3889 4.5L13.3889 7V9C13.3889 11.2091 11.5981 13 9.38894 13H5.38894H1.38894Z" fill={fill} />
      <path d="M5.38894 13H1.38894V7L1.38892 4.5M5.38894 13V8H9.38894V13M5.38894 13H9.38894M1.38892 4.5V4.5C1.38893 2.567 2.95594 1 4.88894 1H7.38894H13.3889L13.3889 4.5M1.38892 4.5H13.3889M13.3889 4.5L13.3889 7V9C13.3889 11.2091 11.5981 13 9.38894 13V13" stroke={stroke} />
    </svg>
  )
}

export default IconBoxShop14